import type { HomeTile } from '@/features/home/homeTiles'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Note, Ribbon } from '@/ui/core/note'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { router } from 'expo-router'

type HeroTile = Extract<HomeTile, { kind: 'hero' }>

/** The one thing that outranks everything else on the page today, if there is one. */
export const HeroCard = ({ tile }: { tile: HeroTile }) => {
	if (tile.hero === 'payment-attention') {
		return (
			<Note tone="ink" padded={false}>
				<Ribbon tone="accent">Needs a look</Ribbon>
				<VStack gap={12} className="px-6 pt-5 pb-6">
					<Header variant="h2" tone="ground">
						{"A payment didn't\ngo through."}
					</Header>
					<Text size="body0" tone="white" className="opacity-85">
						Update your card and nothing else changes.
					</Text>
					<Button
						variant="ground"
						size="lg"
						fullWidth
						onPress={() => router.navigate('/billing')}
					>
						<ButtonText>Update my card</ButtonText>
					</Button>
				</VStack>
			</Note>
		)
	}

	return (
		<Note tone="ink" padded={false}>
			<Ribbon tone="accent">Your results are in</Ribbon>
			<VStack gap={12} className="px-6 pt-5 pb-6">
				<Header variant="h2" tone="ground">
					{'Your smile\nscore is ready.'}
				</Header>
				<Text size="body0" tone="white" className="opacity-85">
					What we saw at your last visit, and what to do next.
				</Text>
				<Button
					variant="ground"
					size="lg"
					fullWidth
					onPress={() => router.push('/score')}
				>
					<ButtonText>Read it</ButtonText>
				</Button>
			</VStack>
		</Note>
	)
}
